import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWebcam = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.9994 14L19.4715 15.7175C20.9122 17.3984 21.6325 18.2389 21.6502 18.9504C21.6655 19.5688 21.3938 20.1595 20.9143 20.5503C20.3626 21 19.2556 21 17.0418 21H6.9568C4.74285 21 3.63587 21 3.08412 20.5503C2.6046 20.1595 2.33292 19.5688 2.34827 18.9504C2.36594 18.2388 3.08637 17.3983 4.52723 15.7174L5.99937 14M18.9991 10C18.9991 13.866 15.8651 17 11.9991 17C8.13309 17 4.99908 13.866 4.99908 10C4.99908 6.13401 8.13309 3 11.9991 3C15.8651 3 18.9991 6.13401 18.9991 10ZM14.9991 10C14.9991 11.6569 13.6559 13 11.9991 13C10.3422 13 8.99908 11.6569 8.99908 10C8.99908 8.34315 10.3422 7 11.9991 7C13.6559 7 14.9991 8.34315 14.9991 10Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgWebcam;
